import axios from "axios";
import { logsInterceptor } from "./interceptors/logsInterceptor";
import { REGEX } from "shared/config";
import BaseApiService from "./services/baseApiService";
import { useAuthPersistedStore } from "shared/store/useAuthPersistedStore";

const isLocalHost = new RegExp(REGEX.is_local_host).test(window.location.host);

const api = axios.create({
  withCredentials: true,
  baseURL: isLocalHost ? "http://localhost:8000" : "/",
  headers: {
    "X-User-Time-Zone": Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

api.interceptors.response.use(
  logsInterceptor.onFulfilled,
  logsInterceptor.onRejected
);

api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    if (error?.response?.status == 400 || error?.response?.status === 401) {
      useAuthPersistedStore.getState().setIsLoggedIn(false);
    }
    throw error;
  }
);

let baseApiService = new BaseApiService();

export { BaseApiService, baseApiService };
export default api;
